/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioHeadphonesIcon16Light } from './MediaAudioHeadphonesIcon16Light';
import { MediaAudioHeadphonesIcon16Regular } from './MediaAudioHeadphonesIcon16Regular';
import { MediaAudioHeadphonesIcon16Solid } from './MediaAudioHeadphonesIcon16Solid';
import { MediaAudioHeadphonesIcon20Light } from './MediaAudioHeadphonesIcon20Light';
import { MediaAudioHeadphonesIcon20Regular } from './MediaAudioHeadphonesIcon20Regular';
import { MediaAudioHeadphonesIcon20Solid } from './MediaAudioHeadphonesIcon20Solid';
import { MediaAudioHeadphonesIcon24Regular } from './MediaAudioHeadphonesIcon24Regular';
import { MediaAudioHeadphonesIcon24Solid } from './MediaAudioHeadphonesIcon24Solid';
import { MediaAudioHeadphonesIcon32Regular } from './MediaAudioHeadphonesIcon32Regular';
import { MediaAudioHeadphonesIcon64Regular } from './MediaAudioHeadphonesIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioHeadphonesIcon16Light,
        regular: MediaAudioHeadphonesIcon16Regular,
        solid: MediaAudioHeadphonesIcon16Solid,
    },
    20: {
        light: MediaAudioHeadphonesIcon20Light,
        regular: MediaAudioHeadphonesIcon20Regular,
        solid: MediaAudioHeadphonesIcon20Solid,
    },
    24: {
        regular: MediaAudioHeadphonesIcon24Regular,
        solid: MediaAudioHeadphonesIcon24Solid,
    },
    32: {
        regular: MediaAudioHeadphonesIcon32Regular,
    },
    64: {
        regular: MediaAudioHeadphonesIcon64Regular,
    },
};
export var MediaAudioHeadphonesIcon = forwardRef('MediaAudioHeadphonesIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
